import React from 'react';
import BaseIcon ,{ IconProps as BaseIconProps }from './BaseIcon';
import './icon.less';

export type IconType = BaseIconProps['icon'];
export type IconProps = Omit<BaseIconProps, 'onClick' | 'icon'> & {
  spin?: boolean;
  onClick?: React.MouseEventHandler<HTMLElement>;
  icon?: IconType;
  color?: string; // color 可以传 colors.Gray01 也可以是 Gray1 。组件进行了兼容，如果传 colors.Gray01，则颜色赋值给了 svg 标签。传 Gray1 则赋值给了 i 标签。
};

const Icon = (props: IconProps) => {
  const { className = '', spin, onClick, icon, style = {}, ...others } = props;
  const spinCls = spin ? 'ui-docs-icon-spin' : '';

  const iconStyle = { ...style ,color:'#fff'};
  const iconAttr: {
    tabIndex?: number;
  } = {};

  if (onClick) {
    iconAttr.tabIndex = -1;
  }

  const IconNode = icon && <BaseIcon icon={icon} {...others} />;

  return (
    <i
      className={`ui-docs-icon anticon ${spinCls} ${className}`}
      style={iconStyle}
      onClick={onClick}
      {...iconAttr}
    >
      {IconNode}
    </i>
  );
};

export default Icon;
